import { api } from '@/lib/api';
import type { TabName, TabResponse } from './types';

/**
 * One call renders one whole tab. Coordinates are optional — omit them and the backend
 * falls back to the saved address, then to rating order (see `location_source`).
 */
export async function fetch_tab(
  tab: TabName,
  coords?: { lat: number; lng: number },
): Promise<TabResponse> {
  const params = coords ? { lat: coords.lat, lng: coords.lng } : {};
  const res = await api.get<TabResponse>(`/user/${tab}`, { params });
  return res.data;
}
